import { authenticatedFetch } from './auth';

export interface AccountInfo {
  resource_id: string;
  iban: string | null;
  name: string | null;
  currency: string;
  status: string | null;
  product: string | null;
  cash_account_type: string | null;
}

export interface AccountBalance {
  balance_type: string;
  amount: number;
  currency: string;
}

export interface AccountWithBalances extends AccountInfo {
  balances: AccountBalance[];
}

export interface BankAccounts {
  aspsp: string;
  bank_name: string;
  consent_id: string;
  accounts: AccountWithBalances[];
}

export interface ListAccountsResponse {
  banks: BankAccounts[];
}

/**
 * List all accounts for the authenticated PSU, grouped by bank.
 */
export async function listAccounts(): Promise<ListAccountsResponse> {
  const res = await authenticatedFetch('/v1/accounts');
  if (!res.ok) {
    const body = await res.json().catch(() => ({ message: 'Failed to load accounts' }));
    throw new Error(body.message || 'Failed to list accounts');
  }
  return res.json();
}
